// @flow

import * as React from 'react';
import { FormCheckmark, FormClose } from 'grommet-icons';


type Props = {
    value: boolean,
}

const BooleanColumn = (props: Props) => {
    const { value } = props;
    return value ? <FormCheckmark /> : <FormClose />;
};

export default BooleanColumn;
